import * as v from 'valibot';

export const TeamSchema = v.object({
  name: v.string(),
  teamId: v.number(),
});

export const TeamsSchema = v.object({
  data: v.array(TeamSchema),
});

export type TTeam = v.Output<typeof TeamSchema>;
export type TTeams = TTeam[];
